import { Injectable } from '@angular/core';
import * as moment from 'moment';
import * as jwt_decode from 'jwt-decode';

@Injectable()
export class AppUtils {
    public ProcessErrorResponse(toastr: any, response: any) {
        const error = response.error;
        if (response.status === 400) {
            if (error instanceof Array) {
                error.forEach(function (item) {
                    toastr.error(item);
                });
            } else {
                toastr.error(error);
            }
        } else {
            toastr.error('Internal server error.');
        }
    }

    public getContestStartTimeline(startDate: string) {
        const dayDifference = moment(startDate).diff(moment(), 'days');
        return dayDifference + (dayDifference > 1 ? ' Days' : ' Day');
    }

    public getFormattedDate(date: string, format: string) {
        if (!format) {
            format = 'MM/DD/YYYY';
        }
        return date ? moment(date).format(format) : 'N/A';
    }

    public getDateForNgDatePicker(date: string) {
        const m = moment(date);
        return { year: m.year(), month: m.month(), day: m.date() };
    }

    public getMapped(source: any, target: any) {
        Object.assign(target, source);
    }

    public isUserAuthenticated() {
        if (localStorage.getItem('AuthToken')) {
            return true;
        }
        return false;
    }

    public getUserRole() {
        const authToken = localStorage.getItem('AuthToken');
        if (!authToken) {
            return '';
        }
        const decodedToken = jwt_decode(authToken);
        return decodedToken
            .role
            .toString()
            .toUpperCase();
    }
}



// WEBPACK FOOTER //
// ./src/helpers/app.utils.ts